<template>
    <div class="input-group">
        <input type="tel" :name="fieldName" :id="getFieldId" class="form-control" :class="{ 'is-invalid' : fieldIsInvalid }" :readonly="fieldIsReadonly" ref="input" v-model="value">
    </div>
</template>

<script>
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'
import utils from 'intl-tel-input/build/js/utils.js'
import _debounce from 'lodash/debounce'

export default {
    name: 'InternationalTelephoneInput',
    props: {
        fieldId: {
            type: String,
            required: false,
            default: null,
        },
        fieldName: {
            type: String,
            required: true,
            default: null,
        },
        fieldValue: {
            type: String,
            required: false,
            default: null,
        },
        fieldIsInvalid: {
            type: Boolean,
            required: true,
            default: false,
        },
        fieldIsReadonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        numberType: {
            type: String,
            required: false,
            default: 'MOBILE',
        },
    },
    computed: {
        getFieldId() {
            return this.fieldId ? this.fieldId : this.fieldName
        },
    },
    data() {
        return {
            value: null,
            formatter: null,
        }
    },
    watch: {
        value: _debounce(function () {
            this.format()
        }, 250)
    },
    methods: {
        format() {
            if (this.formatter === null) return

            const number = this.formatter.getNumber(intlTelInputUtils.numberFormat.E164)

            this.formatter.setNumber(number)
        },
        init() {
            this.formatter = intlTelInput(this.$refs.input, {
                utilsScript: utils,
                allowDropdown: true,
                autoInsertDialCode: true,
                countrySearch: true,
                formatAsYouType: false,
                formatOnDisplay: false,
                initialCountry: 'nl',
                nationalMode: false,
                placeholderNumberType: this.numberType.toUpperCase(),
                showFlags: true,
                showSelectedDialCode: false,
            })

            this.value = this.fieldValue

            setTimeout(() => this.format(), 200)
        },
    },
    mounted() {
        this.init()
    },
}
</script>
